import React from 'react';
import { withStyles } from '@material-ui/core/styles'
import { Table, TableHead, TableRow, TableBody, TableCell, Link, Typography, IconButton,
        Tooltip, TableSortLabel, Grid, InputAdornment } from '@material-ui/core'
import { Link as RouterLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useFormInput } from './CustomHooks'
import CustomizedTextField from './CustomizedTextField';
import Pagination from 'react-bootstrap/Pagination'
import './custom.scss';
import { format } from 'date-fns'
import SearchIcon from '@material-ui/icons/Search';

const styles = theme => ({
    tableHeaderCell: {
        minWidth: 100,
        borderStyle: "solid",
        borderWidth: 2,
        borderColor: theme.palette.secondary.main,
        color: theme.palette.text.primary,
        fontSize: 14,
        fontWeight: "bold",
        backgroundColor: theme.palette.secondary.main,
        padding: 0,
        '&:last-child': {
          paddingRight: 0,
        },
    },
    tableHeaderRow: {
        height: 30,
    },
    tableRow: {
        height: 40,
    },
    tableCell: {
        borderStyle: "solid",
        borderWidth: 2,
        borderColor: theme.palette.secondary.main,
        padding: "4px, 24px, 4px, 24px",
    },
    searchGrid: {
        marginBottom: 20,
    },
    totalText: {
        marginLeft: 15,
    },
    pagination:{
        marginTop: 30,
    },
    iconButton: {
        padding: 5,
    }
})
function SortableLabel(props){
    return(
        <Tooltip
            title="Sort"
            placement='bottom-end'
            enterDelay={300}
        >
            <TableSortLabel
                active={props.active}
                hideSortIcon
                direction={props.order}
                onClick={props.handleSort}
                IconComponent={(props) => <FontAwesomeIcon {...props} size="lg" icon={["fa","caret-down"]}/>}
            >
                {props.label}
            </TableSortLabel>
        </Tooltip>
    )
}

function ReportsTable(props) {
    const { classes, reports, adminView, handleDelete, downloadReportPDF } = props
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('id');
    const [page, setPage] = React.useState(0);
    const searchText = useFormInput("");
    const rowsPerPage = 10;
    React.useEffect(()=>{
        setPage(0);
    },[searchText.value]);
    const handleRequestSort = property => event => {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    }
    function stableSort(array, cmp) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
      return stabilizedThis.map(el => el[0]);
    }
    function getSorting(order, orderBy) {
      return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
    }
    function desc(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
      return 0;
    }
    function filterFunc(input){
        if(searchText.value===""){
            return true;
        }
        const searchTerms = searchText.value.split(/[\s,]+/);
        const notContained = searchTerms.some(searchTerm=>{
            let containsTerm = false;
            Object.values(input).forEach(field=>{
                if(field.toString().toLowerCase().includes(searchTerm.toLowerCase())){
                    containsTerm = true;
                }
            })
            return !containsTerm
        })
        return !notContained;
    }
    function handlePageChange(pageNum){
        setPage(pageNum);
    }
    const filteredReports = reports?reports.filter(n=>filterFunc(n)):[]
    const numPages = Math.ceil(filteredReports.length/rowsPerPage);
    function handlePageIncrease(){
        if(page<numPages-1){
            setPage(page+1);
        }
    }
    function handlePageDecrease(){
        if(page>0){
            setPage(page-1);
        }
    }
    return (
        <div>
            <Grid className={classes.searchGrid} container alignItems='center'>
                <CustomizedTextField
                    variant="outlined"
                    endAdornment={<InputAdornment><SearchIcon/></InputAdornment>}
                    {...searchText}
                />
                <Typography className={classes.totalText} variant="h5">
                    Total : {filteredReports.length}
                </Typography>
            </Grid>
            <Table>
                <TableHead>
                    <TableRow className={classes.tableHeaderRow}>
                        <TableCell className={classes.tableHeaderCell} align="center">
                            <SortableLabel
                                order={order}
                                active={orderBy==="id"}
                                handleSort={handleRequestSort("id")}
                                label="Report ID"
                            />
                        </TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">
                            <SortableLabel
                                order={order}
                                active={orderBy==="event"}
                                handleSort={handleRequestSort("event")}
                                label="Event"
                            />
                        </TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">
                            <SortableLabel
                                order={order}
                                active={orderBy==="hospital"}
                                handleSort={handleRequestSort("hospital")}
                                label="Hospital"
                            />
                        </TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">
                            <SortableLabel
                                order={order}
                                active={orderBy==="department"}
                                handleSort={handleRequestSort("department")}
                                label="Department"
                            />
                        </TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">View Report</TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">Download</TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">
                            <SortableLabel
                                order={order}
                                active={orderBy==="date"}
                                handleSort={handleRequestSort("date")}
                                label="Report Date/Time"
                            />
                        </TableCell>
                        {adminView?
                            <TableCell className={classes.tableHeaderCell} align="center">
                                Delete
                            </TableCell>:undefined
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {stableSort(filteredReports, getSorting(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map(report=>
                    <TableRow className={classes.tableRow} key={report.id}>
                        <TableCell className={classes.tableCell} align="center">
                            <Typography>{report.id}</Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                            <Typography>{report.event}</Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                            <Typography>{report.hospital}</Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                            <Typography>{report.department}</Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                            <Typography>
                                <Link component={RouterLink} to={`/reportDetails/${report.id}`}>Report</Link>
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                            <IconButton className={classes.iconButton}
                                onClick={()=>downloadReportPDF(report.id)}
                            >
                                <FontAwesomeIcon size="xs" icon={["fa","file-download"]}/>
                            </IconButton>
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                            <Typography>{format(report.date,'MMM DD, YYYY hh:mm A')}</Typography>
                            {/* <Typography>{report.date}</Typography> */}
                        </TableCell>
                        {adminView?
                            <TableCell className={classes.tableCell} align="center">
                                <IconButton className={classes.iconButton} 
                                    onClick={()=>handleDelete(report.id)}
                                >
                                    <FontAwesomeIcon size="xs" icon={["fa","trash-alt"]}/>
                                </IconButton>
                            </TableCell>:undefined
                        }
                    </TableRow>)}
                </TableBody>
            </Table>
            <div>
                
            <Pagination className={classes.pagination}>
                <Pagination.First onClick={()=>handlePageChange(0)}/>
                <Pagination.Prev onClick={handlePageDecrease} disabled={page===0}/>
                {page-10>0?<Pagination.Ellipsis/>:undefined}
                {Array(numPages).fill().map((_, i) => {
                    if(i>page-10 && i<page+10){
                        return(
                            <Pagination.Item key={i} 
                                active={page===i} 
                                onClick={()=>handlePageChange(i)}
                            >
                                {i+1}
                            </Pagination.Item>
                        );
                    }
                })}
                {page+10<numPages-1?<Pagination.Ellipsis/>:undefined}
                <Pagination.Next onClick={handlePageIncrease} disabled={page>=numPages-1}/>
                <Pagination.Last onClick={()=>handlePageChange(numPages-1)}/>
            </Pagination>
            </div>
        </div>
    )
} 

export default withStyles(styles)(ReportsTable);